import { render } from "./LocaleFlag.vue?vue&type=template&id=79591948"
import script from "./LocaleFlag.vue?vue&type=script&lang=js"
export * from "./LocaleFlag.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__